import React, { useEffect, useMemo, useState } from "react";
import {
  formatDataVmailNatcomMissCall,
  getDateChangeTime,
} from "../../../../../helper/helper";
import { TYPE_GET_DATE } from "../../../../../helper/const";
import FilterTime from "../../../../components/FilterTime";
import { useSelector } from "react-redux";
import DashboardCompare from "../../../components/DashboardCompare";
import { Tabs } from "antd";
import TabPane from "antd/es/tabs/TabPane";

export default function Compare({ tabActive, handleGetData, isMissCall = false }) {
  const [startDate, setStartDate] = useState(
    getDateChangeTime(TYPE_GET_DATE.oneDayAgo)
  );
  const [endDate, setEndDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));
  const { result = {} } =
    useSelector((state) => state.reducerNatcom?.data) || {};
  const { data: missCallData } = result;

  useEffect(() => {
    if (tabActive !== "3") return;

    handleGetData(startDate, endDate);
  }, [startDate, endDate, tabActive, handleGetData]);


  const dataChartTotal = useMemo(() => {
    const convertData = formatDataVmailNatcomMissCall(
      missCallData,
      startDate,
      endDate,
      true
    );
    return convertData || [];
  }, [missCallData, startDate, endDate]);

  const dataChartCheckSub = useMemo(() => {
    const convertData = formatDataVmailNatcomMissCall(
      missCallData,
      startDate,
      endDate,
      false,
      true
    );
    return convertData || [];
  }, [missCallData, startDate, endDate]);

  const dataChartNotEnough = useMemo(() => {
    const convertData = formatDataVmailNatcomMissCall(
      missCallData,
      startDate,
      endDate,
      false,
      false,
      true,
    );
    return convertData || [];
  }, [missCallData, startDate, endDate]);

  const dataChartCancel = useMemo(() => {
    const convertData = formatDataVmailNatcomMissCall(
      missCallData,
      startDate,
      endDate,
      false,
      false,
      false,
      true,
    );
    return convertData || [];
  }, [missCallData, startDate, endDate]);

  const dataChartInvalid = useMemo(() => {
    const convertData = formatDataVmailNatcomMissCall(
      missCallData,
      startDate,
      endDate,
      false,
      false,
      false,
      false,
      true,
    );
    return convertData || [];
  }, [missCallData, startDate, endDate]);

  console.log('dataChartTotal:: ', dataChartTotal);

  return (
    <>
      <div
        className="position-relative d-flex justify-right mb-2"
        style={{ justifyContent: "right" }}
      >
        <FilterTime
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
        />
      </div>

      <Tabs defaultActiveKey="1">
        <TabPane tab="Total" key="1">
          <div>
            <DashboardCompare
              dataChart={dataChartTotal}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
        <TabPane tab="Check Sub Error" key="2">
          <div>
            <DashboardCompare
              dataChart={dataChartCheckSub}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
        <TabPane tab="Not Enough Money" key="3">
          <div>
            <DashboardCompare
              dataChart={dataChartNotEnough}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
        <TabPane tab="Cancel" key="4">
          <div>
            <DashboardCompare
              dataChart={dataChartCancel}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
        <TabPane tab="Call Invalid" key="5">
          <div>
            <DashboardCompare
              dataChart={dataChartInvalid}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
      </Tabs>
    </>
  );
}
